import { SingleInputConnectIntegrationFormDrawerContent } from '@modules/integrationsV2/components/AddIntegrationFormDrawerContent/SingleInputConnectIntegrationFormDrawerContent';
import { GetAddIntegrationFormDrawerContentProps } from '@modules/integrationsV2/utils/getAddIntegrationFormDrawerContent';
import { useState } from 'react';

export const DelightedFormDrawerContent = ({
  integrationType,
  integrationChannel,
  onDrawerClose,
  integrationID,
}: GetAddIntegrationFormDrawerContentProps) => {
  const [apiToken, setApiToken] = useState('');

  return (
    <SingleInputConnectIntegrationFormDrawerContent
      inputFieldData={apiToken}
      setInputFieldData={setApiToken}
      integrationChannel={integrationChannel}
      integrationType={integrationType}
      integrationData={{
        delighted: {
          apiToken: apiToken,
        },
      }}
      updateAuthData={{
        delighted: {
          apiToken: apiToken,
        },
      }}
      textFieldProps={{
        label: 'API Token',
        placeholder: 'Enter API Token',
      }}
      onDrawerClose={onDrawerClose}
      integrationID={integrationID}
    />
  );
};
